import { defineComponent as _defineComponent } from 'vue'
import GridMenu from '@/components/trip/contentView/GridMenu.vue'
import { documentModule } from '@/store'
import { Document } from '@/types/document'
import { DocumentType, GridContentType } from '@/utils/enums'
import { formatFileName, isPDF } from '@/utils/utility-manager'
import { formattedDate } from '@/utils/date-utils'


export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentListItem',
  props: {
    document: null,
    showMenu: { type: Boolean, default: true }
  },
  emits: ["unlink"],
  setup(__props: any) {




return { __sfc: true,GridMenu, documentModule, DocumentType, GridContentType, formatFileName, isPDF, formattedDate }
}

})